import { render, staticRenderFns } from "./AddOrRemove.vue?vue&type=template&id=09274730&scoped=true&"
import script from "./AddOrRemove.vue?vue&type=script&lang=ts&"
export * from "./AddOrRemove.vue?vue&type=script&lang=ts&"
import style0 from "./AddOrRemove.vue?vue&type=style&index=0&id=09274730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09274730",
  null
  
)

export default component.exports